import { useState, useEffect } from "react";
import DataTableComponent from "../../components/DataTableComponent";

export default function RegionTable({ regionData }) {
  const [filterValue, setFilterValue] = useState("");
  const [displayData, setDisplayData] = useState(regionData);

  useEffect(() => {
    setDisplayData(
      regionData.filter(
        (item) =>
          item.regione &&
          item.regione.toLowerCase().includes(filterValue.toLowerCase())
      )
    );
  }, [regionData, filterValue]);

  const columns = [
    {
      name: "Regione",
      selector: (row) => row.regione,
      sortable: true,
    },
    {
      name: "Numero compilazioni",
      selector: (row) => row.count,
      sortable: true,
    },
  ];

  const handleChange = (e) => {
    setFilterValue(e.target.value);
  };

  return (
    <>
      <DataTableComponent
        columns={columns}
        displayData={displayData}
        filterValue={filterValue}
        handleChange={handleChange}
        placeholder='Regione'
        defaultSortFieldId={2}
        defaultSortAsc={false}
      />
    </>
  );
}
